const KEY = 'erp-language'
const supported = value => ['ky', 'ru', 'en'].includes(value === 'kg' ? 'ky' : value) ? (value === 'kg' ? 'ky' : value) : null
const read = key => { try { return localStorage.getItem(key) } catch { return null } }
export const preferenceKey = userId => userId ? `${KEY}:user:${userId}` : KEY
export function readLanguage(userId) { return supported(read(preferenceKey(userId))) || supported(read(KEY)) || 'ky' }
export function writeLanguage(language, userId) {
  const next = supported(language)
  if (!next) return false
  try { localStorage.setItem(preferenceKey(userId), next); localStorage.setItem(KEY, next) } catch { /* Storage may be unavailable. */ }
  return true
}
export function getSavedLanguage(userId) { return supported(read(preferenceKey(userId))) }
